import React from "react";
import { SealCheckIcon } from "@phosphor-icons/react";
import { BotCard } from "./Catalog";
import { gbp, pct } from "@/lib/customerApi";

export default function PassedSection({ data }) {
  const groups = data?.passed || [];
  return (
    <section id="passed" data-testid="passed-section" className="relative z-10 max-w-[1400px] mx-auto px-6 pb-16">
      <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#2ECA7F] flex items-center gap-2">
        <SealCheckIcon size={14} weight="fill" /> Passed the 2025+ unseen-data backtest
      </div>
      <h2 className="text-3xl font-medium tracking-tight mt-2">Positive backtests on data they weren't built on.</h2>
      <p className="text-sm text-[#94A3B8] mt-3 max-w-3xl">
        These bots passed walk-forward and robustness checks, then showed a net-positive result in a backtest on 2025+ market data
        that wasn't used to build them. This is still a simulation, not real trading, and is not a reliable indicator of future performance.
      </p>
      {groups.length === 0 ? (
        <div className="mt-6 mono text-xs text-[#64748B]" data-testid="passed-empty">No bots have passed the 2025 exam yet - check back soon.</div>
      ) : (
        groups.map((g) => (
          <div key={g.symbol} className="mt-8" data-testid={`passed-symbol-${g.symbol}`}>
            <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">{g.symbol} · {g.symbol_name}</div>
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {g.bots.map((b, i) => (
                <div key={b.store_id} className="flex flex-col gap-2">
                  <BotCard b={b} rank={i + 1} />
                  <div className="text-[11px] text-[#94A3B8] px-1" data-testid={`passed-stats-${b.store_id}`}>
                    2025+ backtest: {gbp(b.holdout?.net_profit)} over {b.holdout?.backtest_months} mo · PF {b.holdout?.profit_factor ?? "-"} · DD {pct(b.holdout?.max_dd_pct)} · {b.holdout?.total_trades} trades
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </section>
  );
}
